import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section id="system" className="py-16 bg-white" data-id="element-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl font-bold mb-4" data-id="element-27">
            "The System" - Our Flagship Innovation
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-28">
            In order to further meet our customers' regulatory needs, we
            developed "The System." This is an engineered Emergency
            Identification/Document Program which consists of Evacuation
            Displays, Fire/Safety Identification signs, Emergency Employee
            Pamphlets and Fire Department pre-plan maps. When "The System" is
            implemented, the overall Emergency Preparedness Program is greatly
            enhanced.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-29">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-6" data-id="element-30">
            <p className="text-lg mb-4" data-id="element-31">
              Our flagship innovation, "The System," unites clear evacuation
              maps, precise safety signage, employee emergency guides, and
              detailed fire department pre-plans into one powerful, integrated
              program that transforms your emergency readiness.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-32">
            <p className="text-lg mb-4" data-id="element-33">
              Whether you need high-quality stock signs or fully customized
              wayfinding and fire system displays, we deliver everything
              required to safeguard lives, streamline emergency response, and
              meet every regulatory mandate with confidence and clarity.
            </p>
            <p className="text-lg" data-id="element-34">
              With a full line of stock fire and safety signs, we also produce
              custom Fire System Displays, Directories and other wayfinding
              products to meet our customer's needs.
            </p>
          </div>
        </div>
      </div>
    </section>;
}